import type { DestinationAddress } from 'src/data/models/destination-address.model';
import type { Destination } from 'src/data/models/destination.model';
import type { Pagination } from 'src/data/models/pagination.model';
import type { SettingModel } from 'src/data/models/setting.model';
import { FetchHttpClient } from '../config/fetch';
import type { IHttpClient } from '../config/http-client.interface';

const MasterRemoteData = (client: IHttpClient) => ({
  getDestinations: async (p?: {
    limit?: number;
    skip?: number;
    search?: string;
    province?: string;
    sortBy?: string;
    sortOrder?: string;
  }): Promise<Pagination<Destination>> => {
    const response = await client.get({
      path: '/v1/destinations',
      queryParams: {
        limit: p?.limit,
        skip: p?.skip,
        search: p?.search,
        province: p?.province?.toLocaleLowerCase(),
        sortBy: p?.sortBy,
        sortOrder: p?.sortOrder,
      },
    });
    return response;
  },
  getDestinationsGroups: async (p?: {
    search?: string;
    province?: string;
  }): Promise<Destination[]> => {
    console.log({
      province: p?.province,
      search: p?.search,
    });
    const response = await client.get({
      path: '/v1/public/destinations/address/group',
      queryParams: {
        province: p?.province,
        search: p?.search,
      },
    });
    return response;
  },
  getDestinationsAddresses: async (p?: {
    limit?: number;
    skip?: number;
    search?: string;
    destinationId?: string;
    sortBy?: string;
    sortOrder?: string;
  }): Promise<Pagination<DestinationAddress>> => {
    const response = await client.get({
      path: '/v1/public/destinations/address',
      queryParams: {
        limit: p?.limit,
        skip: p?.skip,
        search: p?.search,
        destination: p?.destinationId,
        sortBy: p?.sortBy,
        sortOrder: p?.sortOrder,
      },
    });
    return response;
  },
  getDestinationsAddressById: async (id: string): Promise<DestinationAddress> => {
    const response = await client.get({
      path: `/v1/public/destinations/address/${id}`,
    });
    return response;
  },
  getSettings: async (): Promise<SettingModel> => {
    const response = await client.get({
      path: `/v1/public/setting`,
      cache: 'no-store',
    });
    return response;
  },
});

export const masterRemotedata = MasterRemoteData(FetchHttpClient);
